import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import BottomNav from "./BottomNav";

const colors = {
  purple: "#667eea",
};

export default function AppShell() {
  const navRef = useRef<HTMLDivElement>(null);
  const [navH, setNavH] = useState(80);
  const { pathname } = useLocation();

  // Measure bottom bar (including safe-area)
  useEffect(() => {
    const measure = () => {
      if (!navRef.current) return;
      const h = navRef.current.getBoundingClientRect().height;
      setNavH(Math.round(h));
      document.documentElement.style.setProperty("--bottom-nav-h", `${Math.round(h)}px`);
    };
    measure();
    const ro = new ResizeObserver(measure);
    if (navRef.current) ro.observe(navRef.current);
    return () => ro.disconnect();
  }, []);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pathname]);

  return (
    <div
      style={{
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        minHeight: "100vh",
        background: colors.purple
      }}
    >
      {/* Main content */}
      <main style={{
        background: "#fff",
        borderRadius: "14px",
        margin: "0 auto",
        width: "min(720px, 100%)",
        boxShadow: "0 4px 12px rgba(0,0,0,.08)",
        padding: "clamp(16px, 4vw, 28px)",
        minHeight: "100vh",
        // Reserve space for bottom menu
        paddingBottom: `calc(var(--bottom-nav-h, ${navH}px) + 12px)`
      }}>
        <Outlet />
      </main>

      {/* Bottom navigation */}
      <BottomNav ref={navRef} />
    </div>
  );
}
